(() => {
  // src/card-dropdown.ts
  var CardDropdownComponent = class extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector(".card-dropdown__trigger");
      this._menu = this.querySelector(".card-dropdown__menu");
      this._input = this.querySelector('input[type="hidden"]');
      this._abort = new AbortController();
      const { signal } = this._abort;
      this._trigger.addEventListener("click", () => this._toggle(), { signal });
      this._menu.addEventListener("click", (e) => this._select(e), { signal });
      this._menu.addEventListener("keydown", (e) => this._onMenuKey(e), { signal });
      document.addEventListener("click", (e) => {
        if (!this.contains(e.target)) this._close();
      }, { signal });
    }
    disconnectedCallback() {
      this._abort.abort();
    }
    _toggle() {
      this._isOpen() ? this._close() : this._open();
    }
    _isOpen() {
      return this._trigger.getAttribute("aria-expanded") === "true";
    }
    _open() {
      this._trigger.setAttribute("aria-expanded", "true");
      this._menu.removeAttribute("hidden");
      const selected = this._menu.querySelector(".card-dropdown__option--selected") || this._menu.querySelector(".card-dropdown__option");
      selected == null ? void 0 : selected.focus();
    }
    _close() {
      this._trigger.setAttribute("aria-expanded", "false");
      this._menu.setAttribute("hidden", "");
    }
    _select(e) {
      const option = e.target.closest(".card-dropdown__option");
      if (!option) return;
      if (option.getAttribute("aria-disabled") === "true" || option.dataset.available === "false") return;
      const val = option.dataset.value;
      const label = option.dataset.label || val;
      const variantId = option.dataset.variantId || "";
      const sellingPlanId = option.dataset.sellingPlanId || "";
      const sellingPlanDiscount = parseInt(option.dataset.sellingPlanDiscount || "0", 10);
      const subscribePrice = parseInt(option.dataset.subscribePrice || "0", 10);
      const price = parseInt(option.dataset.price || "0", 10);
      const selectedCard = this.querySelector(".card-dropdown__selected-card");
      if (selectedCard) selectedCard.innerHTML = option.innerHTML;
      this._input.value = val;
      this._menu.querySelectorAll(".card-dropdown__option").forEach((o) => {
        const selected = o === option;
        o.classList.toggle("card-dropdown__option--selected", selected);
        o.setAttribute("aria-selected", selected ? "true" : "false");
      });
      this._close();
      this._trigger.focus();
      this.dispatchEvent(new CustomEvent("dropdown:change", {
        bubbles: true,
        detail: { value: val, label, variantId, sellingPlanId, sellingPlanDiscount, subscribePrice, price }
      }));
    }
    _onMenuKey(e) {
      var _a, _b, _c;
      const options = [...this._menu.querySelectorAll(".card-dropdown__option")];
      const idx = options.indexOf(document.activeElement);
      if (e.key === "ArrowDown") {
        e.preventDefault();
        (_a = options[(idx + 1) % options.length]) == null ? void 0 : _a.focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        (_b = options[(idx - 1 + options.length) % options.length]) == null ? void 0 : _b.focus();
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        (_c = document.activeElement) == null ? void 0 : _c.click();
      } else if (e.key === "Escape") {
        this._close();
        this._trigger.focus();
      }
    }
  };
  customElements.define("card-dropdown-component", CardDropdownComponent);
})();
